import { z } from "zod/v4";
import { CleanString } from "./cleanString.ts";

const normalizeString = (value: string) => value.trim().toLowerCase();

export const normalizeEmail = (email: string): string => normalizeString(email);

export const NormalizedEmail = z.email().nonempty().transform(normalizeEmail);

export const NormalizedName = CleanString.max(201).transform((name) =>
  normalizeString(name),
);
